import {
    ShoppingOutlined,
    CodeOutlined,
    SearchOutlined,
    BellOutlined,
    ShoppingCartOutlined,
    LayoutOutlined,
    LaptopOutlined,
    CheckOutlined,
} from '@ant-design/icons';
import React from 'react';

export const shopPageDetail = {
    title: 'Shop Page - Clone giao diện Shopee',
    description: () => (
        <>
            <h2 className="text-2xl font-bold mb-4">Tổng quan</h2>
            <p className="mb-4">
                Shop Page là một dự án cá nhân được thực hiện với mục đích chính là học tập và rèn luyện kỹ năng
                frontend. Dự án tập trung vào việc tái tạo giao diện trang danh sách sản phẩm của Shopee, một nền tảng
                thương mại điện tử phổ biến tại Việt Nam và khu vực Đông Nam Á.
            </p>
            <p className="mb-4">
                Được xây dựng với HTML, CSS và JavaScript thuần, dự án này đã giúp tôi củng cố kiến thức nền tảng về lập
                trình web frontend, tập trung vào việc tạo giao diện người dùng chính xác và responsive mà không phụ
                thuộc vào các framework hiện đại. Mặc dù đơn giản, dự án vẫn mang lại nhiều kinh nghiệm quý báu về cách
                thiết kế và tổ chức mã nguồn cho các ứng dụng web thương mại điện tử.
            </p>

            <h3 className="text-xl font-semibold mb-3 mt-6">Các tính năng chính</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div className="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-500">
                    <h4 className="font-semibold text-blue-700 mb-2">Danh sách sản phẩm</h4>
                    <p className="text-sm text-gray-700">
                        Hiển thị danh sách sản phẩm với hình ảnh, giá cả, đánh giá và thông tin khuyến mãi một cách
                        chính xác như giao diện gốc của Shopee.
                    </p>
                </div>

                <div className="bg-green-50 p-4 rounded-lg border-l-4 border-green-500">
                    <h4 className="font-semibold text-green-700 mb-2">Tìm kiếm sản phẩm</h4>
                    <p className="text-sm text-gray-700">
                        Giao diện thanh tìm kiếm với các gợi ý sản phẩm phổ biến và lịch sử tìm kiếm của người dùng.
                    </p>
                </div>

                <div className="bg-purple-50 p-4 rounded-lg border-l-4 border-purple-500">
                    <h4 className="font-semibold text-purple-700 mb-2">Giỏ hàng</h4>
                    <p className="text-sm text-gray-700">
                        Hiển thị giao diện giỏ hàng với danh sách sản phẩm đã thêm, tính toán tổng tiền và các tùy chọn
                        thanh toán.
                    </p>
                </div>

                <div className="bg-amber-50 p-4 rounded-lg border-l-4 border-amber-500">
                    <h4 className="font-semibold text-amber-700 mb-2">Thông báo</h4>
                    <p className="text-sm text-gray-700">
                        Giao diện phần thông báo về đơn hàng, khuyến mãi và cập nhật từ người bán.
                    </p>
                </div>
            </div>
        </>
    ),
    technologies: () => (
        <>
            <h2 className="text-2xl font-bold mb-6">Công nghệ sử dụng</h2>

            <div className="space-y-6">
                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-blue-500 to-indigo-600 px-6 py-4 flex items-center">
                        <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                            <CodeOutlined className="text-blue-600 text-xl" />
                        </div>
                        <h3 className="text-xl font-bold text-white">Frontend & Styling</h3>
                    </div>

                    <div className="p-6">
                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
                            <div className="bg-blue-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/html5.png" alt="HTML5" className="w-6 h-6" />
                                </div>
                                <span className="font-medium text-gray-800">HTML5</span>
                                <span className="text-xs text-gray-500 mt-1">Structure</span>
                            </div>

                            <div className="bg-blue-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/css3.png" alt="CSS3" className="w-6 h-6" />
                                </div>
                                <span className="font-medium text-gray-800">CSS3</span>
                                <span className="text-xs text-gray-500 mt-1">Styling</span>
                            </div>

                            <div className="bg-blue-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/javascript.png" alt="JavaScript" className="w-6 h-6" />
                                </div>
                                <span className="font-medium text-gray-800">JavaScript</span>
                                <span className="text-xs text-gray-500 mt-1">Functionality</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-purple-500 to-pink-500 px-6 py-4 flex items-center">
                        <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                            <LaptopOutlined className="text-purple-600 text-xl" />
                        </div>
                        <h3 className="text-xl font-bold text-white">Development Tools</h3>
                    </div>

                    <div className="p-6">
                        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
                            <div className="bg-purple-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/git.png" alt="Git" className="w-8 h-8" />
                                </div>
                                <span className="font-medium text-gray-800">Git</span>
                                <span className="text-xs text-gray-500 mt-1">Version Control</span>
                            </div>

                            <div className="bg-purple-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/vscode.jpeg" alt="VS Code" className="w-8 h-8" />
                                </div>
                                <span className="font-medium text-gray-800">VS Code</span>
                                <span className="text-xs text-gray-500 mt-1">Code Editor</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    ),
    features: () => (
        <>
            <h2 className="text-2xl font-bold mb-6">Tính năng chính</h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-blue-500 to-indigo-600 px-6 py-4 flex items-center">
                        <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                            <ShoppingOutlined className="text-blue-600 text-xl" />
                        </div>
                        <h3 className="text-xl font-bold text-white">Danh sách sản phẩm</h3>
                    </div>

                    <div className="p-6">
                        <ul className="space-y-4">
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-blue-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Hiển thị sản phẩm</span> với hình ảnh, giá cả,
                                        đánh giá và thông tin chi tiết
                                    </p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-blue-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Lọc sản phẩm</span> theo nhiều tiêu chí khác
                                        nhau
                                    </p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-blue-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Phân trang</span> và điều hướng giữa các trang
                                        sản phẩm
                                    </p>
                                </div>
                            </li>
                        </ul>

                        <div className="mt-4">
                            <img
                                src="/assets/images/projects/shop-page/danh-sach-san-pham.jpg"
                                alt="Danh sách sản phẩm"
                                className="rounded-lg shadow-sm"
                            />
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-green-500 to-teal-600 px-6 py-4 flex items-center">
                        <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                            <SearchOutlined className="text-green-600 text-xl" />
                        </div>
                        <h3 className="text-xl font-bold text-white">Tìm kiếm sản phẩm</h3>
                    </div>

                    <div className="p-6">
                        <ul className="space-y-4">
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-green-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Thanh tìm kiếm</span> với gợi ý tự động
                                    </p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-green-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Lịch sử tìm kiếm</span> gần đây
                                    </p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-green-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Từ khóa phổ biến</span> được gợi ý
                                    </p>
                                </div>
                            </li>
                        </ul>

                        <div className="mt-4">
                            <img
                                src="/assets/images/projects/shop-page/tim-kiem-san-pham.jpg"
                                alt="Tìm kiếm sản phẩm"
                                className="rounded-lg shadow-sm"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-purple-500 to-pink-500 px-6 py-4 flex items-center">
                        <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                            <ShoppingCartOutlined className="text-purple-600 text-xl" />
                        </div>
                        <h3 className="text-xl font-bold text-white">Giỏ hàng</h3>
                    </div>

                    <div className="p-6">
                        <ul className="space-y-4">
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-purple-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-purple-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Danh sách sản phẩm</span> đã thêm vào giỏ hàng
                                    </p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-purple-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-purple-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Tính toán tổng tiền</span> và áp dụng mã giảm
                                        giá
                                    </p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-purple-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-purple-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Các tùy chọn thanh toán</span> cho đơn hàng
                                    </p>
                                </div>
                            </li>
                        </ul>

                        <div className="mt-4">
                            <img
                                src="/assets/images/projects/shop-page/gio-hang.jpg"
                                alt="Giỏ hàng"
                                className="rounded-lg shadow-sm"
                            />
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-amber-500 to-orange-600 px-6 py-4 flex items-center">
                        <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                            <BellOutlined className="text-amber-600 text-xl" />
                        </div>
                        <h3 className="text-xl font-bold text-white">Thông báo</h3>
                    </div>

                    <div className="p-6">
                        <ul className="space-y-4">
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-amber-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-amber-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Thông báo đơn hàng</span> và cập nhật trạng thái
                                    </p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-amber-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-amber-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Thông báo khuyến mãi</span> từ các cửa hàng yêu
                                        thích
                                    </p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-amber-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-amber-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Cập nhật hệ thống</span> và thông báo quan trọng
                                    </p>
                                </div>
                            </li>
                        </ul>

                        <div className="mt-4">
                            <img
                                src="/assets/images/projects/shop-page/thong-bao.jpg"
                                alt="Thông báo"
                                className="rounded-lg shadow-sm"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    ),
    results: () => (
        <>
            <h2 className="text-2xl font-bold mb-4">Kết quả đạt được</h2>

            <div className="bg-white p-6 rounded-lg shadow-md mb-6">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div className="bg-blue-50 p-4 rounded-lg text-center">
                        <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <CodeOutlined className="text-blue-600 text-xl" />
                        </div>
                        <h3 className="text-lg font-semibold text-gray-800 mb-2">Nâng cao kỹ năng HTML/CSS</h3>
                        <p className="text-gray-700">
                            Cải thiện đáng kể kỹ năng tạo layout phức tạp và responsive với HTML và CSS thuần
                        </p>
                    </div>

                    <div className="bg-green-50 p-4 rounded-lg text-center">
                        <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <LayoutOutlined className="text-green-600 text-xl" />
                        </div>
                        <h3 className="text-lg font-semibold text-gray-800 mb-2">Hiểu sâu về UI/UX</h3>
                        <p className="text-gray-700">
                            Học hỏi các nguyên tắc thiết kế giao diện người dùng từ một nền tảng thương mại điện tử
                            chuyên nghiệp
                        </p>
                    </div>

                    <div className="bg-purple-50 p-4 rounded-lg text-center">
                        <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <ShoppingOutlined className="text-purple-600 text-xl" />
                        </div>
                        <h3 className="text-lg font-semibold text-gray-800 mb-2">Kinh nghiệm e-commerce</h3>
                        <p className="text-gray-700">
                            Hiểu rõ hơn về cấu trúc và giao diện của các trang thương mại điện tử phổ biến
                        </p>
                    </div>
                </div>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-blue-500">
                <p className="text-gray-700 mb-3">
                    Mặc dù đây là một dự án clone đơn giản, nhưng nó đã mang lại giá trị lớn cho quá trình học tập của
                    tôi. Việc tái tạo một giao diện phức tạp như Shopee từ đầu bằng HTML, CSS và JavaScript thuần đã
                    giúp tôi:
                </p>
                <ul className="space-y-2 pl-6 list-disc text-gray-700">
                    <li>Hiểu rõ hơn về cấu trúc DOM và quy trình render của trình duyệt</li>
                    <li>Nắm vững các kỹ thuật CSS như Flexbox, Grid và các media query cho responsive design</li>
                    <li>Học cách tổ chức mã nguồn sạch và có cấu trúc rõ ràng</li>
                    <li>Phát triển kỹ năng để tạo ra UI chính xác và chi tiết</li>
                </ul>
            </div>
        </>
    ),
    screenshots: [
        {
            url: '/assets/images/projects/shop-page/danh-sach-san-pham.jpg',
            caption: 'Trang danh sách sản phẩm',
        },
        {
            url: '/assets/images/projects/shop-page/tim-kiem-san-pham.jpg',
            caption: 'Tìm kiếm sản phẩm',
        },
        {
            url: '/assets/images/projects/shop-page/gio-hang.jpg',
            caption: 'Giỏ hàng',
        },
        {
            url: '/assets/images/projects/shop-page/thong-bao.jpg',
            caption: 'Thông báo',
        },
        {
            url: '/assets/images/projects/shop-page/chuyen-trang-danh-sach-san-pham.jpg',
            caption: 'Chuyển trang danh sách sản phẩm',
        },
    ],
    teamSize: 1,
    duration: '1 tuần',
    role: 'Frontend Developer',
    architecture: 'Static HTML Website',
    responsibilities: [
        'Phân tích và thiết kế giao diện để clone từ Shopee',
        'Xây dựng cấu trúc HTML tương ứng với các phần của trang web',
        'Tạo style với CSS thuần cho từng thành phần giao diện',
        'Thêm các tính năng tương tác cơ bản với JavaScript',
        'Đảm bảo giao diện responsive trên các kích thước màn hình khác nhau',
        'Quản lý mã nguồn với Git',
    ],
};
